<div class="empathy-editor">
  @if (previewMode) {
    <empathy-survey-full-preview [selectedActiveDevice]="selectedActiveDevice"></empathy-survey-full-preview>
  } @else {
    <empathy-main-tabs
      [activeTab]="surveyEditorService.mainTab$()"
      [translationsOnly]="translationsOnly()"
      (tabChange)="surveyEditorService.mainTab$.set($event)"
    ></empathy-main-tabs>

    <div class="empathy-editor__container">
      @switch (activeTab$()) {
        @case (mainTabs.SurveyEditor) {
          <div class="left-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-list-questions
                  [forceActiveQuestion]="forceActiveQuestion$()"
                  (addQuestion)="onAddQuestion()"
                  (addPageBreak)="addPageBreak()"
                  (deleteQuestions)="onRemoveSelectedQuestions()"
                  (duplicateQuestions)="onDuplicateSelectedQuestions()"
                  (moveQuestions)="onMoveSelectedQuestions()"
                  (filterComments)="onFilterComments($event)"
                  (forcedActivation)="forceActiveQuestion$.set(null)"
                ></empathy-list-questions>
              </div>
            </div>
          </div>

          <div class="main-column">
            @if (surveyEditorService.welcomeScreenActive$()) {
              <empathy-welcome-page-form [editorForm]="surveyEditorService.surveyEditor$().form"></empathy-welcome-page-form>
            } @else if (surveyEditorService.endPageScreenActive$()) {
              <empathy-end-page-form [editorForm]="surveyEditorService.surveyEditor$().form"></empathy-end-page-form>
            } @else if (surveyEditorService.surveyEditor$().sources.activeVariable$()) {
              <empathy-variable-form
                [activeVariable]="surveyEditorService.surveyEditor$().sources.activeVariable$()"
                [canComment]="canComment()"
                (addComment)="addComment.emit($event)"
              ></empathy-variable-form>
            } @else {
              <empathy-question-form
                [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"
                (remove)="onRemoveActiveQuestion()"
                (duplicateQuestion)="onDuplicateQuestion()"
                (saveQuestionOnLibrary)="onSaveQuestionOnLibrary()"
                (saveOptionsOnLibrary)="onSaveOptionsOnLibrary()"
              >
                <div slot="tabs">
                  <div class="empathy-editor-tabs-toolbar">
                    <button
                      mat-icon-button
                      title="Conditional Logic"
                      class="empathy-editor-tabs-toolbar__button"
                      [color]="
                        surveyEditorService.activeTab$() === sideTabs.Conditions &&
                        !surveyEditorService.surveyEditor$().activeOption &&
                        !surveyEditorService.surveyEditor$().activeCard
                          ? 'primary'
                          : surveyEditorService.surveyEditor$().activeQuestion?.get('visibleWhen').value.length > 0
                            ? 'alert'
                            : 'light'
                      "
                      (click)="onOpenMainTabPanel(sideTabs.Conditions)"
                    >
                      <fa-icon [icon]="faCodeBranch" matTooltip="Conditional Logic" matTooltipPosition="below"></fa-icon>
                    </button>

                    <button
                      mat-icon-button
                      title="Settings"
                      class="empathy-editor-tabs-toolbar__button"
                      [color]="
                        surveyEditorService.activeTab$() === sideTabs.Settings &&
                        !surveyEditorService.surveyEditor$().activeOption &&
                        !surveyEditorService.surveyEditor$().activeCard
                          ? 'primary'
                          : 'light'
                      "
                      (click)="onOpenMainTabPanel(sideTabs.Settings)"
                    >
                      <fa-icon [icon]="faGear" matTooltip="Settings" matTooltipPosition="below"></fa-icon>
                    </button>

                    @if (canComment()) {
                      <button
                        mat-icon-button
                        title="Comments"
                        class="empathy-editor-tabs-toolbar__button"
                        [color]="
                          surveyEditorService.activeTab$() === sideTabs.Comments &&
                          !surveyEditorService.surveyEditor$().activeOption &&
                          !surveyEditorService.surveyEditor$().activeCard
                            ? 'primary'
                            : 'light'
                        "
                        (click)="onOpenMainTabComments()"
                      >
                        <fa-icon [icon]="faComment" matTooltip="Comments" matTooltipPosition="below"></fa-icon>
                      </button>
                    }

                    <button
                      mat-icon-button
                      title="Preview"
                      class="empathy-editor-tabs-toolbar__button"
                      [color]="
                        surveyEditorService.activeTab$() === sideTabs.Preview &&
                        !surveyEditorService.surveyEditor$().activeOption &&
                        !surveyEditorService.surveyEditor$().activeCard
                          ? 'primary'
                          : 'light'
                      "
                      (click)="onOpenMainTabPanel(sideTabs.Preview)"
                    >
                      <fa-icon [icon]="faEye" matTooltip="Preview" matTooltipPosition="below"></fa-icon>
                    </button>
                  </div>
                </div>
              </empathy-question-form>
            }
          </div>

          <div class="right-side-column">
            <button mat-icon-button color="light" matTooltip="Hide column" class="hide-button" (click)="onToggleRightColumns()">
              <fa-icon [icon]="faChevronsRight"></fa-icon>
            </button>
            <div class="sticky-content">
              <div class="side-content empathy-editor__settings">
                @if (surveyEditorService.surveyEditor$().activeOption) {
                  <mat-tab-group
                    class="empathy-editor-tabs invisible-tabs"
                    mat-align-tabs="start"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                  >
                    <mat-tab animationDuration="0ms" ariaLabel="Conditional Logic">
                      <empathy-conditional-logic
                        [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"
                        [activeOption]="surveyEditorService.surveyEditor$().activeOption"
                      ></empathy-conditional-logic>
                    </mat-tab>
                  </mat-tab-group>
                } @else if (surveyEditorService.surveyEditor$().activeCard) {
                  <mat-tab-group
                    class="empathy-editor-tabs invisible-tabs"
                    mat-align-tabs="start"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                  >
                    <mat-tab animationDuration="0ms" ariaLabel="Conditional Logic">
                      <empathy-conditional-logic
                        [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"
                        [activeCard]="surveyEditorService.surveyEditor$().activeCard"
                      ></empathy-conditional-logic>
                    </mat-tab>
                  </mat-tab-group>
                } @else if (surveyEditorService.surveyEditor$().sources.activeVariable$()) {
                  <mat-tab-group
                    class="empathy-editor-tabs invisible-tabs"
                    mat-align-tabs="start"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                  >
                    @if (canComment()) {
                      <mat-tab animationDuration="0ms" ariaLabel="Comments">
                        <empathy-comments-list
                          [comments]="editorComments"
                          [allowFilterRemoval]="false"
                          [filterValue]="'#' + commentsFilterValue$()"
                          [readonly]="previewMode"
                          (addComment)="addComment.emit($event)"
                          (updateComment)="updateComment.emit($event)"
                          (postReply)="postReply.emit($event)"
                        ></empathy-comments-list>
                      </mat-tab>
                    }
                  </mat-tab-group>
                } @else {
                  <mat-tab-group
                    class="empathy-editor-tabs invisible-tabs"
                    mat-align-tabs="start"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                  >
                    <mat-tab animationDuration="0ms" ariaLabel="Preview" [id]="sideTabs.Preview">
                      <empathy-preview
                        [welcomeScreenActive]="surveyEditorService.welcomeScreenActive$()"
                        [endPageScreenActive]="surveyEditorService.endPageScreenActive$()"
                        [editorForm]="surveyEditorService.surveyEditor$().form"
                        [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion?.value"
                      ></empathy-preview>
                    </mat-tab>

                    @if (!surveyEditorService.welcomeScreenActive$() && !surveyEditorService.endPageScreenActive$()) {
                      <mat-tab animationDuration="0ms" ariaLabel="Conditional Logic" [id]="sideTabs.Conditions">
                        <empathy-conditional-logic [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-conditional-logic>
                      </mat-tab>

                      <mat-tab animationDuration="0ms" ariaLabel="Settings" [id]="sideTabs.Settings">
                        <empathy-question-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-question-settings>
                      </mat-tab>

                      @if (canComment()) {
                        <mat-tab animationDuration="0ms" ariaLabel="Comments" [id]="sideTabs.Comments">
                          <empathy-comments-list
                            [comments]="editorComments"
                            [allowFilterRemoval]="false"
                            [filterValue]="'#' + commentsFilterValue$()"
                            [modifyHashtagCallback]="onUpdateHashtagBasedOnQuestionId"
                            [readonly]="previewMode"
                            (selectHashtag)="onSelectQuestionFromComment($event)"
                            (addComment)="addComment.emit($event)"
                            (updateComment)="updateComment.emit($event)"
                            (postReply)="postReply.emit($event)"
                          ></empathy-comments-list>
                        </mat-tab>
                      }
                    }
                  </mat-tab-group>
                }
              </div>
            </div>
          </div>
        }
        @case (mainTabs.HiddenVariables) {
          <div class="left-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-list-questions-hidden
                  [forceActiveHiddenQuestion]="forceActiveQuestion$()"
                  (filterComments)="onFilterComments($event)"
                  (forcedActivation)="forceActiveQuestion$.set(null)"
                >
                </empathy-list-questions-hidden>

                @if (this.surveyEditorService.surveyEditor$().questions.length > 0) {
                  <div class="side-content-bottom">
                    <button mat-flat-button color="primary" (click)="onAddHiddenQuestion()">
                      <fa-icon [icon]="faPlus"></fa-icon>
                      Add Hidden question
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="main-column">
            @if (surveyEditorService.surveyEditor$().activeHiddenQuestion; as activeHiddenQuestion) {
              <empathy-question-form
                [activeQuestion]="activeHiddenQuestion"
                (remove)="onRemoveActiveHiddenQuestion()"
                (updateCommentsReference)="onUpdateCommentsReference()"
              >
                <div slot="tabs">
                  <div class="empathy-editor-tabs-toolbar">
                    <button
                      mat-icon-button
                      title="Settings"
                      class="empathy-editor-tabs-toolbar__button"
                      [color]="
                        surveyEditorService.activeTab$() === sideHiddenTabs.Settings &&
                        !surveyEditorService.surveyEditor$().activeOption &&
                        !surveyEditorService.surveyEditor$().activeCard
                          ? 'primary'
                          : 'light'
                      "
                      (click)="onOpenMainTabPanel(sideHiddenTabs.Settings)"
                    >
                      <fa-icon [icon]="faGear" matTooltip="Settings" matTooltipPosition="below"></fa-icon>
                    </button>

                    @if (canComment()) {
                      <button
                        mat-icon-button
                        title="Comments"
                        class="empathy-editor-tabs-toolbar__button"
                        [color]="
                          surveyEditorService.activeTab$() === sideHiddenTabs.Comments &&
                          !surveyEditorService.surveyEditor$().activeOption &&
                          !surveyEditorService.surveyEditor$().activeCard
                            ? 'primary'
                            : 'light'
                        "
                        (click)="onOpenSubTabComments()"
                      >
                        <fa-icon [icon]="faComment" matTooltip="Comments" matTooltipPosition="below"></fa-icon>
                      </button>
                    }
                  </div>
                </div>
              </empathy-question-form>
            } @else {
              <div class="main-column__empty">
                <svg width="480" height="392" viewBox="0 0 480 392" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_61_8819" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="-88" width="480" height="480">
                    <rect width="480" height="480" transform="translate(0 -88)" fill="url(#paint0_radial_61_8819)" />
                  </mask>
                  <g mask="url(#mask0_61_8819)">
                    <circle cx="240" cy="152" r="47.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="79.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="111.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="175.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="207.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="239.5" stroke="#EAECF0" />
                  </g>
                  <defs>
                    <radialGradient
                      id="paint0_radial_61_8819"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(240 240) rotate(90) scale(240 240)"
                    >
                      <stop />
                      <stop offset="1" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
                <div class="main-column__empty-title">
                  <fa-icon [icon]="faEyeSlash"></fa-icon>
                  <h2 class="fs__lg fw__500">No hidden questions yet</h2>
                  <span class="fs__md">
                    @if (this.surveyEditorService.surveyEditor$().questions.length > 0) {
                      No problem! Start adding hidden questions by clicking the button below
                    } @else {
                      You will need to add questions to the survey before been able to add hidden questions
                    }
                  </span>
                </div>
                @if (this.surveyEditorService.surveyEditor$().questions.length > 0) {
                  <button mat-flat-button color="primary" (click)="onAddHiddenQuestion()">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    Add Hidden question
                  </button>
                }
              </div>
            }
          </div>

          @if (this.surveyEditorService.surveyEditor$().questionsHidden.length > 0) {
            <div class="right-side-column">
              <div class="sticky-content">
                <div class="side-content empathy-editor__settings">
                  <mat-tab-group
                    class="empathy-editor-tabs"
                    mat-align-tabs="start"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                  >
                    <mat-tab animationDuration="0ms" ariaLabel="Conditional Hidden Logic">
                      <empathy-conditional-logic
                        [activeHiddenQuestion]="surveyEditorService.surveyEditor$().activeHiddenQuestion"
                        [activeHiddenOption]="surveyEditorService.surveyEditor$().activeHiddenOption"
                      ></empathy-conditional-logic>
                    </mat-tab>

                    <mat-tab animationDuration="0ms" ariaLabel="Settings">
                      <empathy-question-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeHiddenQuestion"></empathy-question-settings>
                    </mat-tab>

                    @if (canComment()) {
                      <mat-tab animationDuration="0ms" ariaLabel="Comments">
                        <empathy-comments-list
                          [comments]="editorComments"
                          [allowFilterRemoval]="false"
                          [filterValue]="'#' + commentsFilterValue$()"
                          [modifyHashtagCallback]="onUpdateHashtagBasedOnHiddenQuestionId"
                          [readonly]="previewMode"
                          (selectHashtag)="onSelectQuestionFromComment($event)"
                          (addComment)="addComment.emit($event)"
                          (updateComment)="updateComment.emit($event)"
                          (postReply)="postReply.emit($event)"
                        ></empathy-comments-list>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </div>
            </div>
          }
        }
        @case (mainTabs.Sources) {
          <div class="left-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-list-sources></empathy-list-sources>

                <div class="side-content-bottom">
                  <button mat-flat-button color="primary" (click)="onAddSource()">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    Add Source
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="main-column">
            <empathy-source-form (addSource)="onAddSource()" (remove)="onRemoveSource()"></empathy-source-form>
          </div>

          @if (this.surveyEditorService.surveyEditor$().sources.count$() > 0) {
            <div class="right-side-column">
              <div class="sticky-content">
                <div class="side-content empathy-editor__settings"></div>
              </div>
            </div>
          }
        }
        @case (mainTabs.Translations) {
          <div class="left-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-translations-questions-list></empathy-translations-questions-list>
              </div>
            </div>
          </div>

          <div class="main-column">
            <empathy-translations></empathy-translations>
          </div>

          <div class="right-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-translations-preview></empathy-translations-preview>
              </div>
            </div>
          </div>
        }
        @case (mainTabs.Blocks) {
          <div class="left-side-column">
            <div class="sticky-content">
              <div class="side-content">
                <empathy-list-blocks></empathy-list-blocks>

                @if (this.surveyEditorService.surveyEditor$().questionsCount > 0) {
                  <div class="side-content-bottom">
                    <button mat-flat-button color="primary" (click)="onAddBlock()">
                      <fa-icon [icon]="faPlus"></fa-icon>
                      Create Block
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="main-column">
            @if (surveyEditorService.surveyEditor$().blocks.active$()) {
              <empathy-block-form></empathy-block-form>
            } @else {
              <div class="main-column__empty">
                <svg width="480" height="392" viewBox="0 0 480 392" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_61_8819" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="-88" width="480" height="480">
                    <rect width="480" height="480" transform="translate(0 -88)" fill="url(#paint0_radial_61_8819)" />
                  </mask>
                  <g mask="url(#mask0_61_8819)">
                    <circle cx="240" cy="152" r="47.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="79.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="111.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="175.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="207.5" stroke="#EAECF0" />
                    <circle cx="240" cy="152" r="239.5" stroke="#EAECF0" />
                  </g>
                  <defs>
                    <radialGradient
                      id="paint0_radial_61_8819"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(240 240) rotate(90) scale(240 240)"
                    >
                      <stop />
                      <stop offset="1" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
                <div class="main-column__empty-title">
                  <fa-icon [icon]="faEyeSlash"></fa-icon>
                  <h2 class="fs__lg fw__500">No blocks yet</h2>
                  <span class="fs__md">
                    @if (this.surveyEditorService.surveyEditor$().questionsCount > 0) {
                      No problem! Start creating blocks by clicking the button below
                    } @else {
                      You will need to add questions to the survey before been able to create blocks
                    }
                  </span>
                </div>
                @if (this.surveyEditorService.surveyEditor$().questionsCount > 0) {
                  <button mat-flat-button color="primary" (click)="onAddBlock()">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    Create block
                  </button>
                }
              </div>
            }
          </div>

          @if (this.surveyEditorService.surveyEditor$().blocks.count > 0) {
            <div class="right-side-column">
              <div class="sticky-content">
                <div class="side-content empathy-editor__settings">
                  <mat-tab-group
                    class="empathy-editor-tabs"
                    mat-align-tabs="start"
                    animationDuration="0ms"
                    [selectedIndex]="surveyEditorService.activeTab$()"
                    [disablePagination]="true"
                    (selectedTabChange)="surveyEditorService.activeTab$.set($event.index)"
                  >
                    <mat-tab ariaLabel="Quotas">
                      <empathy-blocks-quota
                        [class.hide]="surveyEditorService.surveyEditor$().blocks.active$().value.type !== blockType.MultiBlock"
                        [attr.aria-hidden]="surveyEditorService.surveyEditor$().blocks.active$().value.type !== blockType.MultiBlock"
                      />
                    </mat-tab>

                    <mat-tab ariaLabel="Conditional Blocks Logic">
                      <empathy-conditional-blocks-logic
                        [activeBlock]="surveyEditorService.surveyEditor$().blocks.active$()"
                        [class.hide]="!surveyEditorService.surveyEditor$().blocks.activeAllowsConditionals$()"
                        [attr.aria-hidden]="!surveyEditorService.surveyEditor$().blocks.activeAllowsConditionals$()"
                      />
                    </mat-tab>
                    <mat-tab ariaLabel="Loop Settings">
                      @if (loopSettingsSelection$()) {
                        <empathy-loop-settings />
                      }
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </div>
            </div>
          }
        }
        @case (mainTabs.FullPreview) {
          <div class="main-column full-preview">
            <empathy-survey-full-preview [variables]="sourceVariables$()" (busyChange)="previewBusy$.set($event)"></empathy-survey-full-preview>
          </div>
          <div class="right-side-column">
            <div class="sticky-content">
              <div class="side-content empathy-editor__settings">
                <mat-tab-group class="empathy-editor-tabs" mat-align-tabs="start" [selectedIndex]="surveyEditorService.activeTab$()" [disablePagination]="true">
                  <mat-tab animationDuration="0ms" ariaLabel="Source Variables">
                    <ng-template mat-tab-label>
                      <fa-icon [icon]="faCode" matTooltip="Source Variables" matTooltipPosition="left"></fa-icon>
                    </ng-template>
                    <empathy-preview-variables-form [disabled]="previewBusy$()" (apply)="sourceVariables$.set($event)"></empathy-preview-variables-form>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </div>
          </div>
        }
        @case (mainTabs.Settings) {
          <div class="left-side-column"></div>
          <div class="main-column">
            <empathy-settings-form [settingsForm]="surveyEditorService.surveyEditor$().form.get('settings') | toFormGroup"></empathy-settings-form>
          </div>

          <div class="right-side-column">
            <div class="sticky-content">
              <div class="side-content empathy-editor__settings no-side-tabs">
                <empathy-welcome-page-preview
                  [editorForm]="surveyEditorService.surveyEditor$().form"
                  (fullPreview)="surveyEditorService.mainTab$.set(mainTabs.FullPreview)"
                ></empathy-welcome-page-preview>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
